module.exports = __webpack_public_path__ + "static/media/potrait.bdd4a10a.jpg";